import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initCallTracking } from "./lib/callTracking";
import { initGa4 } from "./lib/conversionTracking";

initGa4();
initCallTracking();

createRoot(document.getElementById("root")!).render(<App />);
